module.exports = __webpack_public_path__ + "img/background-logo.aaaa60a9.svg";